import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
import { offerBullets } from '../data/content';
export function Offer() {
  return <section id="offer" className="scroll-mt-2 border-y-4 border-gold bg-navy-soft" data-id="element-121" data-mp="17ws2s9xeyodg">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-6" data-id="element-122" data-mp="1mpljfyof9ajp">
        <p className="inline-block rounded-full bg-gold px-3 py-0.5 font-display text-[0.66rem] font-extrabold uppercase tracking-[0.18em] text-navy sm:text-xs" data-id="element-123" data-mp="1hpqsxw8k6mz6">
          SPECIAL LAUNCH OFFER
        </p>
        <h2 className="mt-1.5 font-display text-[1.5rem] font-extrabold uppercase leading-none text-white sm:text-[2.1rem]" data-id="element-124" data-mp="p11wwbmd17ua">
          🔬 FIBER OPTIC <span className="text-signal" data-id="element-125" data-mp="yxxzk0pkuzqx">DIAGNOSTIC PRO™</span>
        </h2>
        <p className="mt-1 font-display text-[0.66rem] font-extrabold uppercase text-white/70 sm:text-[0.82rem]" data-id="element-126" data-mp="ywmwk33yhw0v">
          THE COMPLETE FIBER OPTIC FAULT-FINDING &amp; TROUBLESHOOTING SYSTEM
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[270px] sm:max-w-[340px]" target="checkout" data-id="element-127" data-mp="2af7i8l0vtnr6" />

        <div className="mt-2 rounded-lg border-2 border-gold bg-navy px-3 py-3 text-left shadow-lg" data-id="element-128" data-mp="pjyz5iqcevsz">
          <p className="text-center font-display text-base font-extrabold uppercase text-signal sm:text-xl" data-id="element-129" data-mp="ulenpkrqbkg4">
            Complete 6-in-1 Professional System
          </p>
          <ul className="mt-1.5 grid gap-1 sm:grid-cols-2" data-id="element-130" data-mp="13ip0jak73hn5">
            {offerBullets.map(b => <li key={b} className="flex items-start gap-1.5 text-[0.76rem] leading-tight text-white sm:text-[0.86rem]" data-id="element-131" data-mp="6v0qzgy78xf7">
                <span aria-hidden="true" data-id="element-132" data-mp="bqpwe0wwh8jf">✅</span>
                <span data-id="element-133" data-mp="fu5r2rpesyth">{b}</span>
              </li>)}
          </ul>
          <p className="mt-2.5 text-center font-display text-[0.8rem] font-extrabold uppercase leading-tight text-white sm:text-[1rem]" data-id="element-134" data-mp="kl4c24lcel32">
            🔥 GET FIBER OPTIC DIAGNOSTIC PRO™ TODAY —{' '}
            <span className="whitespace-nowrap rounded bg-gold px-1.5 text-navy" data-id="element-135" data-mp="3oa7iiswaz5j3">$27 USD</span>
          </p>
          <div className="mt-2.5" data-id="element-136" data-mp="vfh6ode273lz">
            <CTAButton label="🔬 GET INSTANT ACCESS" sub="Immediate Digital Access" target="checkout" data-id="element-137" data-mp="vefs3yxu3yzi" />
          </div>
          <p className="mt-2 text-center text-[0.66rem] font-bold uppercase tracking-wide text-gold sm:text-xs" data-id="element-138" data-mp="qge0gpmcercf">
            🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}